export default __webpack_public_path__ + "static/media/item-1.b4c755bc.png";